import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import {DepositSideMenuLinkCasino777Box} from "./deposit-side-menu-link.casino777.box";
import {DepositSideMenuLinkDefaultBox} from "./deposit-side-menu-link.default.box";



export const DepositSideMenuLinkBox = styledByTheme(DepositSideMenuLinkDefaultBox)
    .forCasino777(DepositSideMenuLinkCasino777Box)
    .apply();
